import React from 'react'
import * as AppStore from './../state/app-store'
import {
	Alert,
	Button,
	Card,
	Group,
	List,
	Text,
	ThemeIcon,
} from '@mantine/core'
import { IconCircleCheck, IconPencil, IconPhotoUp } from '@tabler/icons-react'
import NextImage from 'next/image'

import * as Types from '../declarations'
import * as Actions from './../state/actions'
import * as Selectors from './../state/selectors'

import { getDefaultImage } from 'lib/helper'
import { ACCENT_COLOUR } from 'pages/_app'

interface MyComponentProps {
	variant: 'button' | 'modal' | 'banner' | 'alert'
	version: Types.VERSION
	closeModal?: () => void
	meta?: {
		guideCount: number
		reviewCount: number
	}
}

const AccountNudge: React.FC<MyComponentProps> = ({
	variant,
	version,
	closeModal,
	meta,
}: MyComponentProps) => {
	const dispatch = AppStore.useAppDispatch()

	const openSignUp = () => {
		closeModal?.()
		dispatch(Actions.openSignUp())
	}

	const authedUser = AppStore.useAppSelector(Selectors.authedUser)

	const isAuthedUser = !!authedUser

	const title = `Join a community of 
	${version === Types.VERSION.PEAKS ? 'Mountaineers' : 'Trekkers'}`

	const iconProps = {
		size: 24,
		radius: 'xl',
		color: ACCENT_COLOUR,
	}

	return (
		<div className="account-nudge">
			{variant === 'button' && (
				<div>
					<Button
						// variant="white"
						// color="blue"
						// fullWidth
						// mt="md"
						// radius="md"
						size="lg"
						onClick={openSignUp}
					>
						Join the community
						{/* {title} */}
					</Button>
				</div>
			)}
			{variant === 'modal' && (
				<div>
					<Card shadow="sm" padding="lg" radius="md" withBorder>
						<Card.Section>
							<NextImage
								src={getDefaultImage(version)}
								height={200}
								width={404}
								// height={160}
								alt={`Guided ${
									version === Types.VERSION.PEAKS ? 'peaks' : 'trekking'
								}`}
							/>
						</Card.Section>

						<Group justify="apart" mt="md" mb="xs">
							<Text fw={500} mb="md">
								{title}
							</Text>
							{/* <Badge color="pink" variant="light">
								On Sale
							</Badge> */}
						</Group>

						<Text color="dimmed" component="div">
							{/* <p>Join a community so that you can:</p> */}
							<List
								spacing="xs"
								center
								icon={
									<ThemeIcon {...iconProps}>
										<IconCircleCheck size="1rem" />
									</ThemeIcon>
								}
							>
								<List.Item>
									Access {meta?.guideCount?.toLocaleString()} Guides
								</List.Item>

								<List.Item>
									View {meta?.reviewCount?.toLocaleString()} - relevant -
									reviews
								</List.Item>
								<List.Item>
									Learn about new{' '}
									{version === Types.VERSION.PEAKS
										? 'expeditions and mountaineering experiences'
										: 'treks'}
								</List.Item>

								<List.Item>
									Receive a monthly newsletter for mountaineers (optional)
								</List.Item>

								<List.Item>Read articles as published</List.Item>

								<List.Item
									icon={
										<ThemeIcon {...iconProps}>
											<IconPhotoUp size="1rem" />
										</ThemeIcon>
									}
								>
									Share your pictures
								</List.Item>
								<List.Item
									icon={
										<ThemeIcon {...iconProps}>
											<IconPencil size="1rem" />
										</ThemeIcon>
									}
								>
									Edit/correct/add information for routes
								</List.Item>
								{/* // todo: ask/answer questions
								// todo: get notified about new routes 
								// todo: receive discounted trips */}
							</List>
						</Text>

						<Button fullWidth mt="md" radius="md" onClick={openSignUp}>
							Join
						</Button>
					</Card>
				</div>
			)}
			{variant === 'banner' && <div>Banner content</div>}
			{variant === 'alert' && !isAuthedUser && (
				<Alert title={title} mb="xs">
					<Group wrap="nowrap" align="center">
						<div style={{ flexGrow: 1, marginRight: 10 }}>
							{/* Text takes up the remaining space */}
							Connect with guides, receive news on new expeditions/routes,
							upload pictures, share/edit routes.
						</div>
						<Button
							radius="md"
							onClick={openSignUp}
							style={{ whiteSpace: 'nowrap', flexShrink: 0 }} // nowrap + don't shrink: v9 Button clips overflow when squeezed
						>
							Join
						</Button>
					</Group>
				</Alert>
			)}
		</div>
	)
}

export default AccountNudge
